import { chain, toUpper, toLower, includes, get } from "lodash"
import PropTypes from "prop-types"
import { ASC, DESC } from "helpers/sorts"
import { getAdjustedContributorGrouping, getGroupingIdEquality } from "./rollups"

const GROUPING_TYPES = {
  TAG: "tag",
  GICS: "gics",
  CLASSIFICATION: "classification",
  COMPOSITION: "composition",
}

const COMPOSITE_BASE_TYPES = ["INDEX", "ETF"]

export const convertPositionSetType = (positionSetType) => toUpper(positionSetType) === "BASKET" ? "SWAP" : toUpper(positionSetType)

export const isCompositeSecurity = (item) => {
  const { assetClass, assetSubclass } = item
  return assetClass === "swap" || assetSubclass === "etf"
}

export const isCompositeBase = (base) => {
  return base && includes(COMPOSITE_BASE_TYPES, toUpper(base.type))
}

export const getCompositeSecurityUrl = (account, { id, type, assetClass, assetSubclass, internalId, ticker }, modelId) => {
  let url
  if (toLower(type) === "index") {
    url = `/${account}/composite/index/${id || ticker}/assets`
  } else if (toLower(type) === "etf" || assetSubclass === "etf") {
    url = `/${account}/composite/etf/${internalId}/assets`
  } else if (assetClass === "swap") {
    url = `/${account}/composite/basket/${ticker}/assets`
  } else {
    return null
  }
  return `${url}${modelId ? `?model=${modelId}` : ""}`
}

export const getCompositeSecurityTooltip = (item, options = {}) => {
  const { modelSupportsComposites } = options

  const isETF = get(item, "assetSubclass") === "etf" || get(item, "type") === "ETF"
  const isETFWithMissingConstituents = isETF && (!modelSupportsComposites || !item.hasComposition)
  const compositeType = isETF ? "ETF" : toLower(item.type)
  return isETFWithMissingConstituents ? "Analyzing this composite security is not available with the selected model" : `Analyze this ${compositeType}`
}

export const getSortOrderUpdates = ({ by, current }) => {
  if (by !== current.by) {
    return {
      by,
      dir: DESC,
      abs: false,
    }
  }

  const orderUpdates = {
    dir: current.dir === ASC ? DESC : ASC,
  }

  const handleFourWaySort = !includes(current.fourWayExcluded, by)
  if (handleFourWaySort && current.dir === ASC) {
    orderUpdates.abs = !current.abs
  }

  return {
    ...orderUpdates,
  }
}

export const FACTOR_TAB_OPTION_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  background: PropTypes.string,
  color: PropTypes.string.isRequired,
  value: PropTypes.number,
})

export const getGroupingType = (grouping) => {
  if (!grouping) {
    return null
  }
  if (grouping.isTag) {
    return GROUPING_TYPES.TAG
  }
  if (grouping.isClassification && grouping.proprietary) {
    return GROUPING_TYPES.CLASSIFICATION
  }
  if (grouping.isClassification) {
    return GROUPING_TYPES.GICS
  }
  return GROUPING_TYPES.COMPOSITION
}

export const getGrouping = (groupingId, groupingType, rollups, isActive) => {
  return chain(rollups)
    .reduce((options, val) => {
      return [...options, ...get(val, "options")]
    }, [])
    .find(option => getGroupingIdEquality(option, groupingId) && getGroupingType(option) === groupingType)
    .tap(grouping => getAdjustedContributorGrouping(grouping, isActive))
    .value()
}
